import React, { useState, useEffect } from 'react';
import { Breadcrumb, Collapse, Select, Switch } from 'antd';
import { HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import ActivitySwitch from 'modules/layoutModule/components/ActivitySwitch/ActivitySwitch';
import {
  Form,
  Input,
  Button,
  Space,
  Skeleton,
  ConfigProvider,
  BackTop,
} from 'antd';
import { FieldData } from 'rc-field-form/lib/interface';
import { useHistory } from 'react-router-dom';
import plPL from 'antd/lib/locale/pl_PL';
import 'moment/locale/pl';
import FormCoverUpload from 'modules/galleryModules/components/FormCoverUpload';
import {
  getPlantsScheduleRequest,
  getSpecificKnowledgeRequest,
  savePlantsRequest,
} from '../requests/knowledgeRequests';
import TextEditor from '../../layoutModule/components/TextEditor/TextEditor';
import copyToClipboard from 'helpers/copyToClipboard';
const { TextArea } = Input;
const { Panel } = Collapse;

const FertilizationEdit = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const [fields, setFields] = useState<FieldData[]>([]);
  const [loading, toggleLoading] = useState<boolean>(false);
  const history = useHistory();
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [isActivityDisabled, toggleActivityDisable] = useState(false);
  const [fileImage1, setFileImage1] = useState<string | null>(null);
  const [fileImage2, setFileImage2] = useState<string | null>(null);
  const [fileImage3, setFileImage3] = useState<string | null>(null);
  const [fileImage4, setFileImage4] = useState<string | null>(null);

  const [fileImage1Changed, changedFileImage1] = useState<boolean>(false);
  const [fileImage2Changed, changedFileImage2] = useState<boolean>(false);
  const [fileImage3Changed, changedFileImage3] = useState<boolean>(false);
  const [fileImage4Changed, changedFileImage4] = useState<boolean>(false);

  const [contentValue, setContentValue] = useState<string | undefined>('');
  const [content2Value, setContent2Value] = useState<string | undefined>('');
  const [content3Value, setContent3Value] = useState<string | undefined>('');
  const [content4Value, setContent4Value] = useState<string | undefined>('');
  const [content5Value, setContent5Value] = useState<string | undefined>('');
  const [content6Value, setContent6Value] = useState<string | undefined>('');
  const [content7Value, setContent7Value] = useState<string | undefined>('');
  const [content8Value, setContent8Value] = useState<string | undefined>('');
  const [content9Value, setContent9Value] = useState<string | undefined>('');
  const [content10Value, setContent10Value] = useState<string | undefined>('');

  const [plantsSchedule, setPlantsSchedule] = useState([]);

  useEffect(() => {
    toggleLoading(true);

    getPlantsScheduleRequest().then((response) => {
      if (response.data) {
        const sections = response.data.map(
          (section: { name: string; id: number }) => {
            return {
              label: section.name,
              value: section.id,
            };
          }
        );
        sections.unshift({ label: '', value: '' });
        setPlantsSchedule(sections);
      }
    });

    getSpecificKnowledgeRequest(id)
      .then((response) => {
        if (response) {
          toggleLoading(false);
          const { data } = response;

          setFields([
            {
              name: ['id'],
              value: data.rows.id,
            },
            {
              name: ['name'],
              value: data.rows.name,
            },
            {
              name: ['name1'],
              value: data.rows.name1,
            },
            {
              name: ['name2'],
              value: data.rows.name2,
            },
            {
              name: ['name3'],
              value: data.rows.name3,
            },
            {
              name: ['table1'],
              value: data.rows.table1,
            },
            {
              name: ['table2'],
              value: data.rows.table2,
            },
            {
              name: ['table3'],
              value: data.rows.table3,
            },
            {
              name: ['table4'],
              value: data.rows.table4,
            },
            {
              name: ['table5'],
              value: data.rows.table5,
            },
            {
              name: ['table6'],
              value: data.rows.table6,
            },
            {
              name: ['table7'],
              value: data.rows.table7,
            },
            {
              name: ['table8'],
              value: data.rows.table8,
            },
            {
              name: ['table9'],
              value: data.rows.table9,
            },
            {
              name: ['table10'],
              value: data.rows.table10,
            },
            {
              name: ['fileImage1'],
              value: data.rows.fileImage1,
            },
            {
              name: ['fileImage2'],
              value: data.rows.fileImage2,
            },
            {
              name: ['sortOrder'],
              value: data.rows.sortOrder,
            },
            {
              name: ['plants_schedule'],
              value: data.rows.plants_schedule,
            },
            {
              name: ['isActive'],
              value: data.rows.isActive || false,
            },
          ]);
          form.setFieldsValue({
            fileImage1: data.rows?.fileImage1,
            fileImage2: data.rows?.fileImage2,
            fileImage3: data.rows?.fileImage3,
            fileImage4: data.rows?.fileImage4,
          });
          setFileImage1(data.rows?.fileImage1);
          setFileImage2(data.rows?.fileImage2);
          setFileImage3(data.rows?.fileImage3);
          setFileImage4(data.rows?.fileImage4);
          setContentValue(data.rows.description);
          setContent2Value(data.rows.climatic_req);
          setContent3Value(data.rows.nutritional_req);
          setContent4Value(data.rows.natural_fert);
          setContent5Value(data.rows.presowing_fert);
          setContent6Value(data.rows.nitrogen_fert);
          setContent7Value(data.rows.sulfur_fert);
          setContent8Value(data.rows.foliar_feed);
          setContent9Value(data.rows.quality);
          setContent10Value(data.rows.fert_value);
          if (data.rows.activitySwitchDisabled) {
            toggleActivityDisable(true);
          }
        } else {
          history.push('/representatives');
        }
      })
      .catch(() => {
        history.push('/representatives');
      });
  }, []);

  const onFinish = (values: any) => {
    toggleButtonLoading(true);
    savePlantsRequest(values).then(() => {
      toggleButtonLoading(false);
    });
  };

  const onContentEdit = (value: string, field: string) => {
    setFields([
      {
        name: [field],
        value: value,
      },
    ]);
  };

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  const updateCover = (
    e: string,
    field: string,
    coverMethod: (value: string) => void,
    coverMethodChanged: (value: boolean) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
    coverMethodChanged(true);
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Wiedza</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/fertilization">Nawożenie upraw</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/fertilization/${id}`}>Edycja wpisu</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <ConfigProvider locale={plPL}>
        <div className="site-layout-background">
          {loading && <Skeleton active />}
          {!loading && (
            <Form
              layout="vertical"
              fields={fields}
              onFinish={onFinish}
              form={form}
              validateMessages={validateMessages}
            >
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>
              <Form.Item
                name="fileImage1"
                label="Okładka"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <FormCoverUpload
                  cover={fileImage1}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage1',
                      setFileImage1,
                      changedFileImage1
                    )
                  }
                  isNew={fileImage1Changed}
                  id={form.getFieldsValue()?.id}
                  field="fileImage1"
                  number={1}
                  hideTags
                  originalFile
                />
              </Form.Item>
              <Form.Item
                name="fileImage2"
                label="Piktogram biały"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <FormCoverUpload
                  cover={fileImage2}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage2',
                      setFileImage2,
                      changedFileImage2
                    )
                  }
                  isNew={fileImage2Changed}
                  id={form.getFieldsValue()?.id}
                  field="fileImage2"
                  number={2}
                  hideTags
                  originalFile
                />
              </Form.Item>
              <Form.Item
                name="fileImage3"
                label="Piktogram zielony ciemny"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <FormCoverUpload
                  cover={fileImage3}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage3',
                      setFileImage3,
                      changedFileImage3
                    )
                  }
                  isNew={fileImage3Changed}
                  id={form.getFieldsValue()?.id}
                  field="fileImage3"
                  number={3}
                  hideTags
                  originalFile
                />
              </Form.Item>
              <Form.Item
                name="fileImage4"
                label="Piktogram zielony jasny"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <FormCoverUpload
                  cover={fileImage4}
                  setCover={(e) =>
                    updateCover(
                      e,
                      'fileImage4',
                      setFileImage4,
                      changedFileImage4
                    )
                  }
                  isNew={fileImage4Changed}
                  id={form.getFieldsValue()?.id}
                  field="fileImage4"
                  number={4}
                  hideTags
                  originalFile
                />
              </Form.Item>
              <Form.Item
                name="name"
                label="Nazwa w sliderze"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="name2"
                label="Nazwa tytułu wpisu"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="name3"
                label="Nazwa nad menu"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item name="plants_schedule" label="Połącz z harmonogramem">
                <Select
                  showSearch
                  placeholder="Wybierz harmonogram nawożenia"
                  optionFilterProp="children"
                  options={plantsSchedule}
                  filterOption={(input, option) => {
                    // @ts-ignore
                    if (option?.label) {
                      // @ts-ignore
                      const label = option?.label as string;
                      return label.toLowerCase().includes(input.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Form.Item>
              <Form.Item name="name1" label="Nazwa przycisku w harmonogramie">
                <Input />
              </Form.Item>
              <Form.Item
                name="description"
                label="Podstawowe informacje"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <TextEditor
                  initialValue={contentValue}
                  onChange={(value) => onContentEdit(value, 'description')}
                  disableGallery
                />
              </Form.Item>
              <Form.Item
                name="climatic_req"
                label="Wymagania klimatyczno-glebowe"
              >
                <TextEditor
                  initialValue={content2Value}
                  onChange={(value) => onContentEdit(value, 'climatic_req')}
                  disableGallery
                />
              </Form.Item>
              <Form.Item name="nutritional_req" label="Wymagania pokarmowe">
                <TextEditor
                  initialValue={content3Value}
                  onChange={(value) => onContentEdit(value, 'nutritional_req')}
                  disableGallery
                />
              </Form.Item>
              <Form.Item name="natural_fert" label="Nawożenie naturalne">
                <TextEditor
                  initialValue={content4Value}
                  onChange={(value) => onContentEdit(value, 'natural_fert')}
                  disableGallery
                />
              </Form.Item>
              <Form.Item name="presowing_fert" label="Nawożenie przedsiewne">
                <TextEditor
                  initialValue={content5Value}
                  onChange={(value) => onContentEdit(value, 'presowing_fert')}
                  disableGallery
                />
              </Form.Item>
              <Form.Item name="nitrogen_fert" label="Nawożenie azotem">
                <TextEditor
                  initialValue={content6Value}
                  onChange={(value) => onContentEdit(value, 'nitrogen_fert')}
                  disableGallery
                />
              </Form.Item>
              <Form.Item name="sulfur_fert" label="Nawożenie siarką">
                <TextEditor
                  initialValue={content7Value}
                  onChange={(value) => onContentEdit(value, 'sulfur_fert')}
                  disableGallery
                />
              </Form.Item>
              <Form.Item name="foliar_feed" label="Dokarmianie dolistne">
                <TextEditor
                  initialValue={content8Value}
                  onChange={(value) => onContentEdit(value, 'foliar_feed')}
                  disableGallery
                />
              </Form.Item>
              <Form.Item name="quality" label="Wpływ nawożenia na jakość plonu">
                <TextEditor
                  initialValue={content9Value}
                  onChange={(value) => onContentEdit(value, 'quality')}
                  disableGallery
                />
              </Form.Item>
              <Form.Item
                name="fert_value"
                label="Wartość nawozowa resztek pożniwnych"
              >
                <TextEditor
                  initialValue={content10Value}
                  onChange={(value) => onContentEdit(value, 'fert_value')}
                  disableGallery
                />
              </Form.Item>
              <Form.Item
                name="sortOrder"
                label="Kolejność"
                rules={[
                  {
                    required: true,
                  },
                  {
                    validator: async (_, value) => {
                      if (value) {
                        if (
                          (value.length > 5 ||
                            !/^[0-9]*\,?\.?[0-9]*$/.test(value)) &&
                          value.length > 0
                        ) {
                          return Promise.reject(
                            new Error('Proszę podać poprawną wartość!')
                          );
                        }
                      }
                    },
                  },
                ]}
              >
                <Input
                  style={{
                    width: '100px',
                  }}
                />
              </Form.Item>
              <div className="tables-collapse">
                <Collapse defaultActiveKey={[]}>
                  <Panel header="Tabelka 1" key="1" forceRender>
                    <Form.Item name="table1" label="Tabelka 1">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#1')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#1
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 2" key="2" forceRender>
                    <Form.Item name="table2" label="Tabelka 2">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#2')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#2
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 3" key="3" forceRender>
                    <Form.Item name="table3" label="Tabelka 3">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#3')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#3
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 4" key="4" forceRender>
                    <Form.Item name="table4" label="Tabelka 4">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#4')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#4
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 5" key="5" forceRender>
                    <Form.Item name="table5" label="Tabelka 5">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#5')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#5
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 6" key="6" forceRender>
                    <Form.Item name="table6" label="Tabelka 6">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#6')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#6
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 7" key="7" forceRender>
                    <Form.Item name="table7" label="Tabelka 7">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#7')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#7
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 8" key="8" forceRender>
                    <Form.Item name="table8" label="Tabelka 8">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#8')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#8
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 9" key="9" forceRender>
                    <Form.Item name="table9" label="Tabelka 9">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#9')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#9
                    </Button>
                  </Panel>
                  <Panel header="Tabelka 10" key="10" forceRender>
                    <Form.Item name="table10" label="Tabelka 10">
                      <TextArea rows={4} />
                    </Form.Item>
                    <Button
                      type="link"
                      onClick={() => copyToClipboard('TABELKA#10')}
                      style={{ padding: 0, margin: 0 }}
                    >
                      TABELKA#10
                    </Button>
                  </Panel>
                </Collapse>
              </div>
              <ActivitySwitch isActivityDisabled={isActivityDisabled} />
              <Form.Item>
                <Space>
                  <Button
                    type="primary"
                    htmlType="submit"
                    icon={<SaveOutlined />}
                    loading={isSaveButtonLoading}
                  >
                    Zapisz
                  </Button>
                  <Link to="/fertilization">
                    <Button>Powrót</Button>
                  </Link>
                </Space>
              </Form.Item>
            </Form>
          )}
          {loading && (
            <Link to="/fertilization">
              <Button>Powrót</Button>
            </Link>
          )}
          <BackTop />
        </div>
      </ConfigProvider>
    </>
  );
};

export default FertilizationEdit;
